"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _Constants = require("../Constants");

var LookupRecord = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(LookupRecord, _Record);

  function LookupRecord() {
    (0, _classCallCheck2.default)(this, LookupRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LookupRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(LookupRecord, [{
    key: "isKnown",
    value: function isKnown() {
      return Object.keys(_Constants.API_KNOWN_KEY_MAPPINGS).indexOf(this.type) >= 0;
    }
  }, {
    key: "getKnownName",
    value: function getKnownName() {
      if (!this.isKnown()) {
        return undefined;
      }

      return _Constants.API_KNOWN_KEY_MAPPINGS[this.type];
    }
  }, {
    key: "getKnownObject",
    value: function getKnownObject() {
      var _ref;

      if (!this.isKnown()) {
        return undefined;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _Constants.API_KNOWN_VALUE_MAPPINGS[this.type].primaryIdentifier, this.primaryIdentifier), (0, _defineProperty2.default)(_ref, _Constants.API_KNOWN_VALUE_MAPPINGS[this.type].secondaryIdentifier, this.secondaryIdentifier), (0, _defineProperty2.default)(_ref, "fileManagerKey", this.fileManagerKey), _ref;
    }
  }, {
    key: "getIdentifierName",
    value: function getIdentifierName() {
      return _Constants.API_IDENTIFIER_MAPPINGS[this.type];
    }
  }, {
    key: "getIdentifier",
    value: function getIdentifier() {
      return this.primaryIdentifier;
    }
  }, {
    key: "isSameAs",
    value: function isSameAs(lookup) {
      if (this.type === lookup.type) {
        return this.primaryIdentifier === lookup.primaryIdentifier;
      }

      var haveVid = _immutable.Set.of('contact', 'vid').has(this.type) && _immutable.Set.of('contact', 'vid').has(lookup.type);

      var haveCompanyId = _immutable.Set.of('company', 'companyId').has(this.type) && _immutable.Set.of('company', 'companyId').has(lookup.type);

      if (haveVid || haveCompanyId) {
        return this.primaryIdentifier === lookup.primaryIdentifier;
      }

      if (this.type === 'contact' && lookup.type === 'email' || this.type === 'company' && lookup.type === 'domain') {
        return this.secondaryIdentifier === lookup.primaryIdentifier;
      }

      if (this.type === 'email' && lookup.type === 'contact' || this.type === 'domain' && lookup.type === 'company') {
        return this.primaryIdentifier === lookup.secondaryIdentifier;
      }

      return false;
    }
  }, {
    key: "requiresPortalId",
    value: function requiresPortalId() {
      return _Constants.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID.indexOf(this.type) > -1;
    }
  }]);
  return LookupRecord;
}((0, _immutable.Record)({
  type: undefined,
  primaryIdentifier: undefined,
  secondaryIdentifier: undefined,
  fileManagerKey: undefined,
  dimensions: undefined
}, 'LookupRecord'));

exports.default = LookupRecord;
module.exports = exports.default;